/**
 * The platform's name, in the two forms it legitimately takes.
 *
 * OMJ VISION writes itself with an eye in place of the O in VISION. That is a
 * design element, not a spelling: it belongs on a page somebody is looking
 * at, and nowhere a machine reads the name. A browser tab, a PWA manifest, a
 * share card, an `aria-label` and a screen reader all get the plain text.
 *
 * Keeping both here, with one rule for choosing between them, is what stops
 * the pictogram leaking into a page title or the plain form quietly becoming
 * the logo.
 *
 * GoldBot is deliberately not in this file. It is a product inside the
 * platform and keeps its own name everywhere.
 */

/** The readable name. Titles, metadata, accessible names, anything spoken. */
export const PLATFORM_NAME = "OMJ VISION";

/** The owner initials, used where only the short mark fits. */
export const PLATFORM_SHORT_NAME = "OMJ";

/** The product that currently lives inside the platform. */
export const PRODUCT_NAME = "GoldBot";

/** How the product is attributed in a lockup. */
export const PRODUCT_BYLINE = `by ${PLATFORM_NAME}`;

/**
 * The display form, split so the eye can be styled rather than typed.
 *
 * Rendered by `<BrandWordmark>`; the pieces are exported for the rare caller
 * that needs to compose the name itself.
 */
export const WORDMARK = Object.freeze({
  lead: "OMJ VISI",
  trail: "N",
  /** The glyph standing in for the O. */
  eye: "👁️",
});
